export default __webpack_public_path__ + "static/artifakt-legend-regular-a4090f20d9b8763ed7218e9de0f6b582.woff";